import { Box } from "@chakra-ui/react";
import NextLink from "next/link";

/**
 * @typedef {object} Props
 * @property {string} [href]
 * @property {string} [target]
 * @property {import("react").ReactElement} children
 */
/**
 * @param {Props & import("@chakra-ui/react").BoxProps} props
 */
export function Href({ href, target, children, ...otherProps }) {
  return href ? (
    <NextLink href={href} passHref>
      <Box as="a" display="inline" target={target} {...otherProps}>
        {children}
      </Box>
    </NextLink>
  ) : (
    children
  );
}
